package game

import com.soywiz.korge.view.*

data class WorldLayers(
    val water: Container,
    val ground: Container,
    val traps: Container,
    val cave: Container,
    val items: Container
)
